import React, { ReactElement, useState, useEffect } from 'react';
import { ResponseEvent } from '../../../services/api/models/response/responseEvent';
import { getRemainTime } from '../../../common/utils/utils';
import { Image } from 'react-bootstrap';

import './TopPageEventItem.scss';
import moment from 'moment';
import 'moment/locale/ja';

const formatDate = (date: any, isEndDate = false) =>
  moment(date)
    .subtract(isEndDate ? 1 : 0, 'second')
    .locale('ja')
    .format('M月D日(ddd) HH:mm:ss');

/**
 * Event item component for event list
 * @returns React component for event list
 */
export const TopPageEventItem = (event: ResponseEvent): ReactElement => {
  const dayInMS = 24 * 60 * 60 * 1000;
  const startDate = Date.parse(event.startDateTime);
  const endDate = Date.parse(event.endDateTime);
  let currentTime = Date.now();
  const [remainTime, setRemainTime] = useState(' - ');

  useEffect(() => {
    if (
      startDate > currentTime ||
      (startDate <= currentTime && currentTime < endDate)
    ) {
      const checkTimeInterval = setInterval(() => {
        currentTime = Date.now();
        if (startDate > currentTime) {
          setRemainTime(getRemainTime(startDate - currentTime, true));
        } else if (startDate <= currentTime && currentTime < endDate) {
          setRemainTime(getRemainTime(endDate - currentTime, true));
        } else {
          clearInterval(checkTimeInterval);
        }
      }, 1000);
    }
  }, []);

  if (event === undefined) {
    return <></>;
  }

  let textBackgroundColor = '';
  let dateTextString = '';

  if (
    startDate <= currentTime &&
    currentTime < endDate &&
    endDate - currentTime < dayInMS
  ) {
    textBackgroundColor = '#FF64DE';
    dateTextString = `終了まで あと ${remainTime}`;
  } else if (endDate <= currentTime) {
    textBackgroundColor = '#999999';
    dateTextString = 'このイベントは終了しました';
  } else {
    dateTextString = `${formatDate(event.startDateTime)} - ${formatDate(
      event.endDateTime,
      true,
    )}`;
    textBackgroundColor = '#34D8F6';
    if (startDate > currentTime) {
      textBackgroundColor = '#000000';
    }
  }

  return (
    <div>
      {/* Event banner */}
      <Image
        src={event.banner?.uri}
        className="events__list__item-banner"
      ></Image>

      {/* Event date */}
      {event.startDateTime !== undefined && event.endDateTime !== undefined ? (
        <div
          className="events__list__item-info-date"
          style={{ backgroundColor: textBackgroundColor }}
        >
          {dateTextString}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
